module.exports = __webpack_public_path__ + "static/img/aqzs43.8b3c7cc3.jpg";